import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from './navbar';
import Footer from './footer';
import '../index.css';
import { useLocation } from "react-router-dom";

const SchedulerAuditLogs = () => {
  const [schedulerAuditLogs, setSchedulerAuditLogs] = useState([]);
  const [filteredAuditLogs, setFilteredAuditLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const BASE_URL = process.env.REACT_APP_BASE_URL;
    const token = window.sessionStorage.getItem("jwtToken");
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(15); // State for rows per page
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const selectedScheduler = queryParams.get("scheduler");

  useEffect(() => {
    console.log("Selected Scheduler:", selectedScheduler); // Debugging log
    const fetchSchedulerAuditLogs = async () => {
      try {
        const response = await fetch(`${BASE_URL}/fetchSchedulerAuditLog`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        })
        if (!response.ok) {
          throw new Error("Failed to fetch scheduler audit logs");
        }
        const data = await response.json();
        console.log("Fetched Data:", data); // Debugging log
  
        const filteredData = selectedScheduler
          ? data.filter((log) => log.scheduler_name === selectedScheduler)
          : data;
  
        console.log("Filtered Data:", filteredData); // Debugging log
        setFilteredAuditLogs(filteredData);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
  
    fetchSchedulerAuditLogs();
  }, [BASE_URL, selectedScheduler]);
  


  // Update filtered logs when searchTerm changes
  useEffect(() => {
    const filtered = schedulerAuditLogs.filter((log) =>
      log.scheduler_name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredAuditLogs(filtered);
  }, [searchTerm, schedulerAuditLogs]);

  const handlePageChange = (pageNumber) => {
    if (pageNumber > 0 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(parseInt(e.target.value, 10));
    setCurrentPage(1); // Reset to the first page on size change
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredAuditLogs.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(filteredAuditLogs.length / itemsPerPage);


  return (
    <>
      <Navbar />
      <div className="main-content">
        <div className="container-fluid">
          <div className="d-flex justify-content-between mb-3" style={{ marginBottom: '10px', marginTop: '10px' }}>
            <button className="btn btn-primary" onClick={() => navigate(-1)}>
              Back
            </button>
            <h4 className="fw-bold">Scheduler Job Status</h4>
            <h4></h4>
          </div>

          <div className="mb-3">
            <input
              type="text"
              className="form-control"
              placeholder="Search by Scheduler Name"
              value={searchTerm}
              style={{ width: '15%' }}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>

          <div className="table-responsive">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>End Date</th>
                  <th>Scheduler Name</th>
                  <th>Start Date</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {currentItems.length > 0 ? (
                  currentItems.map((item, index) => (
                    <tr key={item.id}>
                      <td>{indexOfFirstItem + index + 1}</td>
                      <td>{item.end_date}</td>
                      <td>{item.scheduler_name}</td>
                      <td>{item.startDate}</td>
                      <td>{item.status}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7">No Scheduler Job Found</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <nav className="d-flex justify-content-center mt-3">
            <ul className="pagination">
              <li className="page-item">
                <button
                  className="page-link"
                  disabled={currentPage === 1}
                  onClick={() => handlePageChange(currentPage - 1)}
                >
                  Previous
                </button>
              </li>
              {[...Array(totalPages)].map((_, index) => (
                <li className="page-item" key={index}>
                  <button
                    className={`page-link ${currentPage === index + 1 ? 'active' : ''}`}
                    onClick={() => handlePageChange(index + 1)}
                  >
                    {index + 1}
                  </button>
                </li>
              ))}
              <li className="page-item">
                <button
                  className="page-link"
                  disabled={currentPage === totalPages}
                  onClick={() => handlePageChange(currentPage + 1)}
                >
                  Next
                </button>
              </li>
            </ul>
            <div className="d-flex justify-content-between align-items-center mb-3">
              <ul>
                Show{' '}
                <select
                  value={itemsPerPage}
                  onChange={handleItemsPerPageChange}
                  className="form-select d-inline-block w-auto"
                >
                  <option value={5}>5</option>
                  <option value={10}>10</option>
                  <option value={15}>15</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                </select>{' '}
                entries
              </ul>
            </div>
          </nav>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default SchedulerAuditLogs;
